import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setTitle('Journalbuchungen ohne Datevkonto')
        .setRoute('journal_lines_without_datev_account'),
];
